import req from './http.js'

// 取得放款作業列表
export const apiGetPaymentOperationList = params => req('post', '/ticket_service/paymentOperation/getPaymentOperationList', params)

// 下載放款作業
export const apiSetPaymentOperationDownloaded = params => req('post', '/ticket_service/paymentOperation/setPaymentOperationDownloaded', params)

// 
export const apiSetPaymentOperationConfirmed = params => req('post', '/ticket_service/paymentOperation/setPaymentOperationConfirmed', params)

// 取得放款作業明細
export const apiGetPaymentOperationDetailSummary = params => req('post', '/ticket_service/paymentOperation/getPaymentOperationDetailSummary', params)

// 取消放款作業
export const apiCancelPaymentOperation = params => req('post', '/ticket_service/paymentOperation/cancelPaymentOperation', params)

// 手動建立放款作業
export const apiCreatePaymentOperationManual = params => req('post','/ticket_service/paymentOperation/createPaymentOperationManual', params)

// 下載放款單
export const apiDownloadPaymentOperationDetailXls = params => req('post', '/ticket_service/paymentOperation/downloadPaymentOperationDetailXls', params)